import { useSnapshot } from 'valtio';
import SlackStore from '../store/slack-store';
export { setSelectedChannel, setUserComment, resetFields } from '../store-actions/slack-store-actions';
export {
  getPublicChannels,
  sendSlackNotification,
} from '../actions/slack-actions';
export const useSlackStore = () => useSnapshot(SlackStore);
